import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogTest from "@/pages/PartsCatalogTest";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-preview")({
  head: () => {
    const head = pageHead({
      title: "RV Parts Storefront Preview",
      description: "Preview the new Rex & Sons RV parts marketplace with parts search, featured categories, trusted brands and a parts request form.",
      path: "/parts-preview",
    });
    return { ...head, meta: [...(head.meta ?? []), { name: "robots", content: "noindex, nofollow" }] };
  },
  component: PartsCatalogTest,
});
